// Copyright (c) 2023 WiseTime. All rights reserved.

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../../app/store"
import {
  RecentNarrative,
  SearchRecentNarrativesResponse
} from "../../generated/wisetime/user/preferences/v4/preferences_pb"

export type NarrativesState = {
  cachedNarratives: RecentNarrative[],
}

export const initialState: NarrativesState = {
  cachedNarratives: []
}

export const slice = createSlice({
  name: "narratives",
  initialState,
  reducers: {
    clearCachedNarratives: (state): void => {
      state.cachedNarratives = []
    },
    setCachedNarratives: (state, action: PayloadAction<SearchRecentNarrativesResponse>): void => {
      state.cachedNarratives = action.payload.narratives
    },
    deleteCachedNarrative: (state, action: PayloadAction<RecentNarrative | undefined>): void => {
      if (action.payload === undefined) {
        return
      }
      const foundIndex = state.cachedNarratives.findIndex(
        x => x.siteId === action.payload?.siteId && x.narrative === action.payload?.narrative)
      if (foundIndex > -1) {
        state.cachedNarratives.splice(foundIndex, 1)
      }
    },
  }
})

export const {
  clearCachedNarratives,
  setCachedNarratives,
  deleteCachedNarrative,
} = slice.actions

export const selectCachedNarratives = (state: RootState): RecentNarrative[] => state.narratives.cachedNarratives

export default slice.reducer
